module.exports = __webpack_public_path__ + "static/media/5.b8e394b5.png";